import React from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

export const AudioModal = ({
  showRecorder,
  setShowRecorder,
  stopAndCloseAudio,
  audioData,
  recStateMsg,
  formatTime,
  startWebAudioRecorder,
  pauseWebAudioRecorder,
  resumeWebAudioRecorder,
  stopWebAudioRecorder,
  increment,
  recState,
  setAudioData,
  setRecState,
  setDataChunksAudio,
  setBase64StringWavAudio,
  clearInterval,
  setTimer,
  setRecStateMsg,
  dialogClassName,
  title = 'Record audio',
}) => {
  return (
    <>
      <Modal show={showRecorder} centered backdrop="static" dialogClassName={dialogClassName}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowRecorder(false);
            stopAndCloseAudio();
          }}
        >
          <Modal.Title>
            <span className="font-weight-bold">{title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {audioData !== null && (
              <>
                <div className="d-flex justify-content-center align-items-center mb-2">
                  <audio
                    controls
                    style={{ width: 300 }}
                    src={audioData}
                  />
                </div>
              </>
            )}
            <h5 className="text-center">Record audio:</h5>
            <p className="text-center">{recStateMsg}</p>
            <p className="text-center">
              <i className="fas fa-microphone-alt fa-1x"></i>{' '}
              {formatTime()}
            </p>
            <div className="d-flex flex-wrap justify-content-center align-items-center audio-controls">
              {recStateMsg === 'paused' ||
              recStateMsg === 'resumed recording...' ? null : (
                <div
                  className="d-flex align-items-center btn-record"
                  onClick={() => startWebAudioRecorder()}
                  style={{
                    backgroundColor:
                      recState === 'recording' ? '#D3D3D3' : '',
                  }}
                >
                  <i className="fas fa-play mr-2"></i>
                  <p className="mb-0">Start</p>
                </div>
              )}
              {recStateMsg !== 'stopped' && (
                <>
                  <div
                    className="d-flex align-items-center btn-record"
                    onClick={() => pauseWebAudioRecorder()}
                    style={{
                      backgroundColor:
                        recState === 'paused' ? '#D3D3D3' : '',
                    }}
                  >
                    <i className="fas fa-pause mr-2"></i>
                    <p className="mb-0">Pause</p>
                  </div>
                  <div
                    className="d-flex align-items-center btn-record"
                    onClick={() => resumeWebAudioRecorder()}
                    style={{
                      backgroundColor:
                        recState === 'resumeRecording'
                          ? '#D3D3D3'
                          : '',
                    }}
                  >
                    <i className="fas fa-reply-all mr-2"></i>
                    <p className="mb-0">Resume</p>
                  </div>
                </>
              )}
              <div
                className="d-flex align-items-center btn-record"
                onClick={() => stopWebAudioRecorder()}
                style={{
                  backgroundColor:
                    recState === 'stopped' ? '#D3D3D3' : '',
                }}
              >
                {' '}
                <i className="fas fa-stop mr-2"></i>
                <p className="mb-0">Stop</p>
              </div>
              {audioData !== null && recStateMsg !== 'recording...' && (
                <div
                  className="d-flex align-items-center btn-record"
                  onClick={() => {
                    setAudioData(null);
                    setRecState('');
                    setDataChunksAudio([]);
                    setRecStateMsg('');
                    setBase64StringWavAudio('');
                    clearInterval(increment.current);
                    setTimer(0);
                    toast.success(`Audio deleted`, {
                      position: 'top-center',
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  }}
                >
                  <i className="fas fa-trash mr-2"></i>
                  <p className="mb-0">Delete</p>
                </div>
              )}
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          {audioData !== null ? (
            <button
              onClick={() => {
                setShowRecorder(false);
                toast.success(`Audio saved`, {
                  position: 'top-center',
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }}
              className="mt-2 mb-2 btn btn-primary"
            >
              Save
            </button>
          ) : null}
        </Modal.Footer>
      </Modal>
    </>
  );
};
